<template>
  <div class="d-flex">
    <div>
      <div class="dot" />
    </div>
    <div class="space_left">
      <label class="text-secodary">{{ labelTitle }}</label>
      <p class="font-weight-bold">
        {{ infoText }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    labelTitle: {
      type: String,
      default: '',
    },
    infoText: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>

.dot {
  width: 4px;
  height: 4px;
  margin-top: 8px;
  border-radius: 100%;
  background-color: #667C99;
}
.space_left{
  margin-left: 5px;
}
</style>
